import axios from "axios";
const apiUrl = "https://medstudent.medicine.psu.ac.th/ems/api";

export default {

  async student() {
    return axios.get(
        apiUrl + "/student_api.php"
      );
  },
  async student_status() {
    return axios.get(
        apiUrl + "/student_status_api.php"
      );
  },
  async student_med(plan) {
    return axios.get(
        apiUrl + "/student_med_api.php?"+new URLSearchParams(plan)
      );
  },
  async student_sci(program) {
    return axios.get(
        apiUrl + "/student_sci_api.php?"+new URLSearchParams(program)
      );
  },
  async grade() {
    return axios.get(
        apiUrl + "/grade_api.php"
      );
  },
  async grade_med(plan) {
    return axios.get(
        apiUrl + "/grade_med_api.php?"+new URLSearchParams(plan)
      );
  },
  async grade_sci(program) {
    return axios.get(
        apiUrl + "/grade_sci_api.php?"+new URLSearchParams(program)
      );
  },
  async resource() {
    return axios.get(
        apiUrl + "/resource_api.php"
      );
  },
  async resource_article_detail() {
    return axios.get(
        apiUrl + "/resource_article_detail_api.php"
      );
  },
  async resource_article_top() {
    return axios.get(
        apiUrl + "/resource_article_top_api.php"
      );
  },
  async resource_article_min() {
    return axios.get(
        apiUrl + "/resource_article_min_api.php"
      );
  },
  async resource_patient_detail() {
    return axios.get(
        apiUrl + "/resource_patient_detail_api.php"
      );
  },
  async resource_room_detail() {
    return axios.get(
        apiUrl + "/resource_room_detail_api.php"
      );
  },
  async resource_room_top() {
    return axios.get(
        apiUrl + "/resource_room_top_api.php"
      );
  },
  async resource_room_min() {
    return axios.get(
        apiUrl + "/resource_room_min_api.php"
      );
  },
  async subject() {
    return axios.get(
        apiUrl + "/subject_api.php"
      );
  },
  async subject_med() {
    return axios.get(
        apiUrl + "/subject_med_api.php"
      );
  },
  async subject_sci() {
    return axios.get(
        apiUrl + "/subject_sci_api.php",
      );
  },
  async subject_open(course) {
    return axios.get(
      apiUrl + "/subject_open_api.php?"+new URLSearchParams(course),
    );
  },
  async teacher() {
    return axios.get(
        apiUrl + "/teacher_api.php"
      );
  },
  async teacher_other() {
    return axios.get(
        apiUrl + "/teacher_other_api.php"
      );
  },
  async teacher_hospital() {
    return axios.get(
        apiUrl + "/teacher_hospital_api.php"
      );
  },
  async teacher_hospital_other() {
    return axios.get(
        apiUrl + "/teacher_hospital_other_api.php"
      );
  },
  async teacher_list() {
    return axios.get(
        apiUrl + "/teacher_list_api.php"
      );
  },
  async teacher_subject() {
    return axios.get(
        apiUrl + "/teacher_subject_api.php"
      );
  },
  async teacher_hour() {
    return axios.get(
        apiUrl + "/teacher_hour_api.php"
      );
  },
  async elog() {
    return axios.get(
        apiUrl + "/elog_api.php"
      );
  },
  async elog_procedure_accept() {
    return axios.get(
        apiUrl + "/elog_procedure_accept_api.php"
      );
  },
  async elog_procedure_pending() {
    return axios.get(
        apiUrl + "/elog_procedure_pending_api.php"
      );
  },
  async elog_patient_accept() {
    return axios.get(
        apiUrl + "/elog_patient_accept_api.php"
      );
  },
  async elog_patient_pending() {
    return axios.get(
        apiUrl + "/elog_patient_pending_api.php"
      );
  },
  async elog_procedure_accept_sub() {
    return axios.get(
        apiUrl + "/elog_procedure_accept_sub_api.php"
      );
  },
  async elog_procedure_pending_sub() {
    return axios.get(
        apiUrl + "/elog_procedure_pending_sub_api.php"
      );
  },
  async elog_patient_accept_sub() {
    return axios.get(
        apiUrl + "/elog_patient_accept_sub_api.php"
      );
  },
  async elog_patient_pending_sub() {
    return axios.get(
        apiUrl + "/elog_patient_pending_sub_api.php"
      );
  },
  async binlabook() {
    return axios.get(
        apiUrl + "/binlabook_api.php"
      );
  },
  async binlachannel() {
    return axios.get(
        apiUrl + "/binlachannel_api.php"
      );
  },
  async edu_year() {
    return axios.get(
        apiUrl + "/edu_year_api.php"
      );
  },
  async access_token() {
    return axios.get(
        apiUrl + "/access_token_api.php"
      );
  },
  async alumni() {
    return axios.get(
        apiUrl + "/alumni_api.php"
      );
  },
  async calendar() {
    return axios.get(
        apiUrl + "/calendar_api.php"
    );
  },
  async calendar_student(studebt_id) {
    return axios.get(
        apiUrl + "/calendar_student_api.php?"+new URLSearchParams(studebt_id)
    );
  },
  async calendar_med() {
    return axios.get(
        apiUrl + "/calendar_med_api.php"
    );
  },
  async calendar_sci_radio() {
    return axios.get(
        apiUrl + "/calendar_sci_radio_api.php"
    );
  },
  async calendar_sci_therapy() {
    return axios.get(
        apiUrl + "/calendar_sci_therapy_api.php"
    );
  },
  async calendar_sci_er() {
    return axios.get(
        apiUrl + "/calendar_sci_er_api.php"
    );
  },
  async co_act() {
    return axios.get(
        apiUrl + "/co_act_api.php"
      );
  },
  async co_act_med() {
    return axios.get(
        apiUrl + "/co_act_med_api.php"
      );
  },
  async co_act_sci_radio() {
    return axios.get(
        apiUrl + "/co_act_sci_radio_api.php"
    );
  },
  async co_act_sci_therapy() {
    return axios.get(
        apiUrl + "/co_act_sci_therapy_api.php"
    );
  },
  async co_act_sci_er() {
    return axios.get(
        apiUrl + "/co_act_sci_er_api.php"
    );
  },
  async co_act_hour_med(plan) {
    return axios.get(
        apiUrl + "/co_act_hour_med_api.php?"+new URLSearchParams(plan)
      );
  },
  async co_act_hour_sci(program) {
    return axios.get(
        apiUrl + "/co_act_hour_sci_api.php?"+new URLSearchParams(program)
      );
  },
  async smartgrade() {
    return axios.get(
        apiUrl + "/smartgrade_api.php"
      );
  },  
  async smartgrade_report(coruse) {
    return axios.get(
        apiUrl + "/smartgrade_report_api.php?"+new URLSearchParams(coruse)
      );
  },  
  async smartgrade_history(mid) {
    return axios.get(
        apiUrl + "/smartgrade_history_api.php?"+new URLSearchParams(mid)
      );
  },
  async smartgrade_model(data) {
    return axios.get(
        apiUrl + "/smartgrade_model_api.php?"+new URLSearchParams(data)
      );
  },
  async smartgrade_tool(data) {
    return axios.get(
        apiUrl + "/smartgrade_tool_api.php?"+new URLSearchParams(data)
      );
  },
  async smartgrade_grade_most(data) {
    return axios.get(
        apiUrl + "/smartgrade_grade_most_api.php?"+new URLSearchParams(data)
      );
  },
  async smartgrade_grade_least(data) {
    return axios.get(
        apiUrl + "/smartgrade_grade_least_api.php?"+new URLSearchParams(data)
      );
  },
  async smartgrade_grade(data) {
    return axios.get(
        apiUrl + "/smartgrade_grade_api.php?"+new URLSearchParams(data)
      );
  },
  async smartgrade_report_delay(coruse) {
    return axios.get(
        apiUrl + "/smartgrade_report_delay_api.php?"+new URLSearchParams(coruse)
      );
  }, 
};
